<template>
  <div id="values">
    <div class="mt-8 md:grid md:grid-cols-2">
      <SectionHeader icon="account_tree" :title="__('ATS process')" />
      <div
        class="text-xs text-zinc-600 flex items-center text-right justify-end"
      >
        {{
          __(
            "Internal only! Once the job is posted, the internal recruitment process cannot be changed."
          )
        }}
      </div>
    </div>
    <div class="p-8 shadow-md mt-8 rounded-app bg-white relative">
      <div>
        <div>
          <label class="text-sm text-[#58585E] mb-2 block"
            >{{ __("Add ATS process") }} *</label
          >
          <FormSingleselect
            v-model="data.job.process"
            :values="data.options"
            :placeholder="__('Select values')"
            :errors="errors.ats_recruitment_process"
            :required="isJobTemplate ? false : true"
          />
        </div>

        <RecruitmentProcess
          class="mt-8"
          :process="data.job?.steps"
          v-if="data.job?.steps.length > 0"
        />
      </div>
    </div>
  </div>
</template>

<script setup>

import {
  SectionHeader,
  FormSingleselect,
} from "../../../../components/global";

import { __ } from "../../../../helpers";
import { RecruitmentProcess } from "../../../candidate/jobs/components";
import { watch } from "vue";

const props = defineProps({
  data: {
    type: Object,
    mandatory: true,
  },
  errors: {
    type: Object,
    mandatory: true,
  },
  isJobTemplate: {
    type: Boolean,
    default: false,
  },
});

watch(
    () => props.data.job.process,
    (newProcess) => {
      let steps = []
      if (newProcess && typeof newProcess === 'object' && Array.isArray(newProcess.steps)) {
        steps = newProcess.steps
      } else {
        const selected = props.data.options.find(
            (opt) => opt.id === newProcess || opt.value === newProcess
        )
        steps = selected?.steps || []
      }
      props.data.job.steps = steps
    },
)
</script>
